<ul nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="false" class="menu-container">
  <ng-container *ngFor="let item of menu; trackBy: trackNode">
    <ng-template #recursiveMenu let-items>
      <ng-container *ngFor="let item of items; trackBy: trackNode">
        <li *ngIf="item.isTitle" nz-menu-item class="menu-title">
          {{ item.title }}
        </li>

        <ng-container *ngIf="!item.isTitle">
          <li
            *ngIf="ifHasItem(item) || item.children?.length"
            nz-submenu
            [nzTitle]="item.title"
            [nzIcon]="'folder'"
            [nzOpen]="openedSubMenus.has(item.title)"
            (nzOpenChange)="onSubMenuOpenChange(item.title, $event)"
          >
            <ul class="menu-ul">
              <ng-container *ngIf="openedSubMenus.has(item.title) && ifHasItem(item)">
                <li
                  *ngFor="let table of item.tables; trackBy: trackTable"
                  nz-menu-item
                  [nzSelected]="
                    currentPath ===
                    '/dynamic/' + table.id + '/' + (table.type === 1 ? 'chart' : 'table')
                  "
                >
                  <a
                    [routerLink]="['/dynamic', table.id, 'chart']"
                    routerLinkActive="router-link-active"
                    *ngIf="table.type === 1"
                  >
                    <span nz-icon nzType="line-chart"></span>
                    <span>{{ table.title }}</span>
                  </a>
                  <a
                    [routerLink]="['/dynamic', table.id, 'table']"
                    routerLinkActive="router-link-active"
                    *ngIf="table.type !== 1"
                  >
                    <span nz-icon nzType="table"></span>
                    <span>{{ table.title }}</span>
                  </a>
                </li>
              </ng-container>

              <ng-container
                *ngIf="openedSubMenus.has(item.title) && item.children?.length"
                [ngTemplateOutlet]="recursiveMenu"
                [ngTemplateOutletContext]="{ $implicit: item.children }"
              ></ng-container>
            </ul>
          </li>

          <li
            *ngIf="!ifHasItem(item) && !item.children?.length"
            nz-menu-item
            [nzSelected]="isActive(item)"
          >
            <span nz-icon nzType="folder"></span>
            <span>{{ item.title }}</span>
          </li>
        </ng-container>
      </ng-container>
    </ng-template>

    <ng-container
      [ngTemplateOutlet]="recursiveMenu"
      [ngTemplateOutletContext]="rootContext(item)"
    ></ng-container>
  </ng-container>
</ul>
